import { Stack, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import { AM_ERROR_MESSAGE, AM_TOOLTIP_TITLE, DEFAULT_ERROR_MESSAGE, useFormContextRequester } from '../utils/_utils'
import { AmTooltipHelperImage } from '../../../assets/images/image'
import sxs from '../_sxs'

const AmNum = () => {
    const { control } = useFormContextRequester()

    return (
        <Controller
            control={control}
            name="amNum"
            rules={{
                required: DEFAULT_ERROR_MESSAGE,
                pattern: {
                    value: /^(?:\d{9}|\d{15}|\d{16}|\d{17})$/,
                    message: AM_ERROR_MESSAGE,
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    required
                    variant="input"
                    label="Numéro AM"
                    placeholder="0 0 0 0 0 0 0 0 0"
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    sideTooltip={
                        <Stack sx={sxs.tooltipContainer}>
                            <Typography flex={2}>{AM_TOOLTIP_TITLE}</Typography>
                            <AmTooltipHelperImage style={{ flexShrink: 1 }} />
                        </Stack>
                    }
                    {...field}
                    value={field?.value ?? ''}
                />
            )}
        />
    )
}

export default AmNum
